.drawer {
  border-left: 1px var(--content-border-color) solid;
  width: 36rem;
  display: flex;
  flex-direction: column;
}

.content {
  padding: 1.6rem;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex: 1;
  overflow-y: auto;
}

.placeholder {
  height: 100%;
  border-radius: var(--border-radius-medium);
  transition: all 100ms linear;

  &[data-is-over='true'] {
    background-color: var(--bg-elevation-1);
  }

  &[data-is-overlay='true'] {
    position: absolute;
    top: 1.6rem;
    left: 1.6rem;
    right: 1.6rem;
    bottom: 1.6rem;
  }
}

.empty-drawer-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  opacity: 0.6;
  margin-top: 1.6rem;
  max-width: 70%;

  & > p {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--color-texts-low-contrast);
  }
}
